import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-rating', 'rating-singular', 'звезда');
Labels.set('ui-rating', 'rating-plural', 'звезды');
